import Image from 'next/image';
import { Cookie, XMark } from 'public/icons/tsx';
import { Button, Typography } from 'components/common';
import { useEffect, useState } from 'react';
import { getLocalStorage, setLocalStorage } from 'utils/localStorage';
import { ContainerBase } from '../containers';
import Link from 'next/link';
import clsx from 'clsx';

export const CookieBanner: React.FC = () => {
	const [cookieConsent, setCookieConsent] = useState<boolean | null>(null);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		const storedCookieConsent = getLocalStorage('cookie_consent');
		setCookieConsent(storedCookieConsent);
	}, []);

	useEffect(() => setMounted(true), []);

	const onClick = (value: boolean): void => {
		setCookieConsent(value);
		setLocalStorage('cookie_consent', value);
	};

	const isOpen = cookieConsent === null;

	if (!mounted) return null;
	return (
		<ContainerBase className="relative">
			<div className="fixed bottom-3 w-full flex items-center justify-center z-50 px-4">
				<div
					className={clsx(
						'bg-white border border-opacity-primary shadow-xl rounded-2xl max-w-[1262px]',
						'p-7 xl:py-6 xl:px-10 gap-4 xl:gap-8 items-center justify-between',
						isOpen ? 'flex flex-col xl:flex-row' : 'hidden'
					)}
					aria-hidden={!isOpen}
					{...(!isOpen ? { inert: '' as any } : {})}
				>
					<div className="flex items-center gap-4 xl:gap-8 w-full xl:w-auto">
						<Image
							src={'/img/landing/cookies.png'}
							width={60}
							height={60}
							alt="cookies"
							className="block"
							quality={75}
						/>
						<div className="w-full">
							<Typography type="regular-16" className="text-opacity-black">
								This website uses cookies to enhance your experience. By
								continuing to browse the site, you agree to our use of cookies.
								For more details, please review our{' '}
								<Link
									href={'/privacy-policy'}
									target="_blank"
									className="text-main-blue-dark underline"
								>
									Privacy Policy.
								</Link>
							</Typography>
						</div>
					</div>
					<div className="flex flex-col sm:flex-row justify-center xl:justify-end items-center gap-2 w-full xl:w-max">
						<Button
							size="medium"
							decoration="secondary"
							onClick={() => onClick(false)}
							className="w-full sm:w-auto"
						>
							Decline
						</Button>
						<Button
							size="medium"
							decoration="primary"
							className="flex items-center gap-2 w-full sm:w-auto xl:w-full"
							onClick={() => onClick(true)}
						>
							<Cookie />
							Accept
						</Button>
					</div>
					<button onClick={() => onClick(false)} className="hidden xl:block">
						<XMark className="text-[#51526C]" />
					</button>
				</div>
			</div>
		</ContainerBase>
	);
};
